/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CurrencyEnum {
    ALL = 'ALL',
    AFN = 'AFN',
    ARS = 'ARS',
    AWG = 'AWG',
    AUD = 'AUD',
    AZN = 'AZN',
    BSD = 'BSD',
    BBD = 'BBD',
    BDT = 'BDT',
    BYR = 'BYR',
    BZD = 'BZD',
    BMD = 'BMD',
    BOB = 'BOB',
    BAM = 'BAM',
    BWP = 'BWP',
    BGN = 'BGN',
    BRL = 'BRL',
    BND = 'BND',
    KHR = 'KHR',
    CAD = 'CAD',
    KYD = 'KYD',
    CLP = 'CLP',
    CNY = 'CNY',
    COP = 'COP',
    CRC = 'CRC',
    HRK = 'HRK',
    CUP = 'CUP',
    CZK = 'CZK',
    DKK = 'DKK',
    DOP = 'DOP',
    XCD = 'XCD',
    EGP = 'EGP',
    SVC = 'SVC',
    EEK = 'EEK',
    EUR = 'EUR',
    FKP = 'FKP',
    FJD = 'FJD',
    GHC = 'GHC',
    GIP = 'GIP',
    GTQ = 'GTQ',
    GGP = 'GGP',
    GYD = 'GYD',
    HNL = 'HNL',
    HKD = 'HKD',
    HUF = 'HUF',
    ISK = 'ISK',
    INR = 'INR',
    IDR = 'IDR',
    IRR = 'IRR',
    IMP = 'IMP',
    ILS = 'ILS',
    JMD = 'JMD',
    JPY = 'JPY',
    JEP = 'JEP',
    KZT = 'KZT',
    KPW = 'KPW',
    KRW = 'KRW',
    KGS = 'KGS',
    LAK = 'LAK',
    LVL = 'LVL',
    LBP = 'LBP',
    LRD = 'LRD',
    LTL = 'LTL',
    MKD = 'MKD',
    MYR = 'MYR',
    MUR = 'MUR',
    MXN = 'MXN',
    MNT = 'MNT',
    MZN = 'MZN',
    NAD = 'NAD',
    NPR = 'NPR',
    ANG = 'ANG',
    NZD = 'NZD',
    NIO = 'NIO',
    NGN = 'NGN',
    NOK = 'NOK',
    OMR = 'OMR',
    PKR = 'PKR',
    PAB = 'PAB',
    PYG = 'PYG',
    PEN = 'PEN',
    PHP = 'PHP',
    PLN = 'PLN',
    QAR = 'QAR',
    RON = 'RON',
    RUB = 'RUB',
    SHP = 'SHP',
    SAR = 'SAR',
    RSD = 'RSD',
    SCR = 'SCR',
    SGD = 'SGD',
    SBD = 'SBD',
    SOS = 'SOS',
    ZAR = 'ZAR',
    LKR = 'LKR',
    SEK = 'SEK',
    CHF = 'CHF',
    SRD = 'SRD',
    SYP = 'SYP',
    TWD = 'TWD',
    THB = 'THB',
    TTD = 'TTD',
    TRY = 'TRY',
    TVD = 'TVD',
    UAH = 'UAH',
    AED = 'AED',
    GBP = 'GBP',
    USD = 'USD',
    UYU = 'UYU',
    UZS = 'UZS',
    VEF = 'VEF',
    VND = 'VND',
    YER = 'YER',
    ZWD = 'ZWD',
}
